// extracted by mini-css-extract-plugin
export default {"CompanyBooleanFavorite":"styles_CompanyBooleanFavorite__mNnk9"};